import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

// Подключаем плагины dayjs
dayjs.extend(utc)
dayjs.extend(timezone)

/**
 * Форматирует дату в московском часовом поясе
 * @param date - дата для форматирования
 * @param format - формат вывода (по умолчанию 'DD.MM.YYYY HH:mm')
 * @returns отформатированная дата в UTC
 */
export const formatToHumanReadable = (
  date: Date | string | undefined,
  format: string = 'DD.MM.YYYY HH:mm',
): string => {
  if (!date) return ''
  return dayjs(date).tz('UTC').format(format)
}

/**
 * Interprets date components as UTC and creates UTC Date object
 * Takes date components (year, month, day, hour, minute) as if they were in UTC timezone
 * and creates a proper UTC Date, compensating for local timezone offset
 * @param date - date to convert (components will be interpreted as UTC)
 * @returns UTC Date object
 */
export const convertToUTC = (date: Date | string | undefined): Date => {
  if (!date) return new Date()
  return dayjs(date).tz('utc', true).utc().toDate()
}
